import { PosCustomButton } from "../../../../../../../../customComponents/PosCustomButton/PosCustomButton";
import "./loyaltyApplied.css";

export default function LoyaltyAppliedUI({ data, handleOpenloyalty }) {
  return (
    <div className="coupon-wrapper">
      <div className="coupon-inner-wrapper">
        <div className="coupon-box">
          <div className="coupon-left">
            <div className="coupon-checkmark">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20,6 9,17 4,12"></polyline>
              </svg>
            </div>
            <span className="coupon-text">{`Loyalty points worth ${data} applied`}</span>
          </div>

          {/* <PosCustomButton variant={"red-d"} title="Remove" onClickFunction={handleOpenloyalty} /> */}
        </div>
      </div>
    </div>
  );
}
